import ReactDOM from 'react-dom'
import styled from 'styled-components'
import CloseButton from '../generic/CloseButton'
import { SlideInRight } from '../../styles/animations'

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1050;
  background: ${({ theme }) => theme.modal.backdrop};
  opacity: 0.5;
`

const Panel = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1055;
  height: 100dvh;
  width: ${({ $width }) => $width || '480px'};
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.modal.background};
  border-left: 1px solid ${({ theme }) => theme.modal.border};
  box-shadow: -0.25rem 0 1rem ${({ theme }) => theme.modal.shadow};
  animation: ${SlideInRight} 0.22s ease-out forwards;

  @media (max-width: 575.98px) {
    width: 100vw;
  }
`

const HeaderShell = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.modal.divider};

  h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
    color: ${({ theme }) => theme.font.color};
  }
`

const DrawerBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: ${({ $padding }) => $padding || '1rem'};
`

const DrawerHeader = ({ children, onClose }) => (
  <HeaderShell>
    {children}
    <CloseButton handleClick={onClose} $size="1.25rem" $top="0.75rem" $right="0.75rem" />
  </HeaderShell>
)

const Drawer = ({ isOpen, onClose, title, width, children }) => {
  if (!isOpen) return null

  return ReactDOM.createPortal(
    <>
      <Backdrop onClick={onClose} />
      <Panel $width={width} role="dialog" aria-modal="true">
        <DrawerHeader onClose={onClose}>
          <h3>{title}</h3>
        </DrawerHeader>
        {children}
      </Panel>
    </>,
    document.body
  )
}

Drawer.Header = DrawerHeader
Drawer.Body = DrawerBody

export default Drawer
